var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4636 0.75H21.75V9.69231V10.9086L22.8368 10.3624L41.9636 0.75H44.25V41.25H39.3214V25.8462V25.0962H38.5714H32.1429H31.3929V25.8462V41.25H0.75V10.1548L19.4636 0.75ZM26.4643 19.3846V18.6346H25.7143H19.2857H18.5357V19.3846V32.3077V33.0577H19.2857H25.7143H26.4643V32.3077V19.3846ZM13.6071 19.3846V18.6346H12.8571H6.42857H5.67857V19.3846V32.3077V33.0577H6.42857H12.8571H13.6071V32.3077V19.3846Z",
    stroke: "#000064",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndus3);
export default __webpack_public_path__ + "static/media/indus3.3c62ea0cd656d2bb21b673d27293c239.svg";
export { ForwardRef as ReactComponent };